import styled from '@emotion/styled';

export const ReportContainer = styled.div`
  position: relative;
  height: 900px;
  width: 100%;

  .single-beet-delivery-report-container {
    position: absolute;
    top: 50%;
    left: 50%;
    width: calc(100% - 48px);
    height: calc(100% - 48px);
    transform: translate(-50%, -50%);
    box-sizing: border-box;

    iframe {
      width: 100%;
      height: 100%;
      border: none !important;
    }
  }
`;
